module.exports = __webpack_public_path__ + "img/account.962e4b1f.svg";